import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditEducation = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        university_name: '',
        speciality: '',
        date_end: '',
        file_id: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-education?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.university_name) {
            newErrors.university_name = 'Обязательное поле';
        }
        if (formInfo.university_name && (formInfo.university_name.length < 2 || formInfo.university_name.length > 200)) {
            newErrors.university_name = 'Значение не может быть меньше 2 и более 200 символов';
        }

        if (!formInfo.speciality) {
            newErrors.speciality = 'Обязательное поле';
        }
        if (formInfo.speciality && (formInfo.speciality.length < 2 || formInfo.speciality.length > 100)) {
            newErrors.speciality = 'Значение не может быть меньше 2 и более 100 символов';
        }

        if (!formInfo.date_end) {
            newErrors.date_end = 'Обязательное поле';
        }

        if (action=='add' && !files.diploma) {
            newErrors.diploma = 'Прикрепите файл';
        }

    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('university_name', formInfo.university_name);
        formData.append('speciality', formInfo.speciality);
        formData.append('date_end', normalizeDate(formInfo.date_end));

        if (files.diploma) {
        formData.append('file_diploma', files.diploma);
        }

        axios.put('/api/add-new-education', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            openTimeModal('Данные успешно сохранены', 'success');
            setFiles({
                certificate: null,
            });
            onSuccess();
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`}</a>);
        })
    }

    const changeData = () => {
        axios.put(`/api/change-education`, {
            id: formInfo.id,
            user_id: userId,
            university_name: formInfo.university_name,
            speciality: formInfo.speciality,
            date_end: normalizeDate(formInfo.date_end),
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        diploma: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений об образовании
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Наименование ВУЗа</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.university_name} 
                                onChange={handleChange('university_name')} 
                                className={errorsForm.university_name ? 'inputError' : ''}
                                placeholder='Полное название без сокращений' 
                                minLength='' 
                                maxLength='200' 
                                disabled={loading}
                                required />
                                {errorsForm.university_name && <div className='errorUnderInput'>{errorsForm.university_name}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Специальность</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.speciality} 
                                onChange={handleChange('speciality')} 
                                className={errorsForm.speciality ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='100' 
                                disabled={loading}
                                required />
                                {errorsForm.speciality && <div className='errorUnderInput'>{errorsForm.speciality}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата окончания</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_end?.split('T')[0]}
                                onChange={handleChange('date_end')} 
                                className={errorsForm.date_end ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_end && <div className='errorUnderInput'>{errorsForm.date_end}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Скан диплома</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить диплом'
                                        file={files.diploma}
                                        buttonLabel='Прикрепить диплом'
                                        onChange={handleFileChange('diploma')}
                                        onReset={handleFileReset('diploma')}
                                    />
                                    {errorsForm.diploma && <div className='errorUnderInput'>{errorsForm.diploma}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditEducation;